/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import ModalProvider from "react-modal";
import { Text, Img, Button, List, Line, Input } from "components";
import "react-circular-progressbar/dist/styles.css";
import { contact_detail } from "app/constants";

const HelpPopUp = (props) => {
  const informations = contact_detail;

  const WhatsAppDPA = () => {
    const phoneNumber = "62081110100936";
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
    window.open(whatsappURL, "_blank");
  };

  const EmailDPA = () => {
    const emailAddress = "support@tselpvdo.id";
    const subject = "Support VRBT";

    window.location.href = `mailto:${emailAddress}?subject=${encodeURIComponent(
      subject
    )}`;
  };

  return (
    <>
      <ModalProvider
        appElement={document.getElementById("root")}
        className="m-auto"
        overlayClassName="bg-black_900_66 fixed flex h-full inset-y-[0] w-full"
        {...props}
      >
        <div className="absolute bg-black_900_66 flex flex-col h-full inset-[0] items-center justify-center m-auto p-[160px] md:px-10 sm:px-5 w-full">
          <div className="bg-white_A700 flex flex-col items-center justify-center my-12 self-stretch w-full rounded-2xl">
            <Input
              wrapClassName="flex w-full"
              className="font-semibold leading-[normal] p-0 placeholder:text-gray_800 text-gray_800 text-left text-lg w-full"
              name="frame764"
              placeholder="Contact Information"
              suffix={
                <Img
                  src={process.env.PUBLIC_URL + "/images/img_icroundclose.svg"}
                  className="ml-[35px] my-px"
                  style={{ cursor: "pointer" }}
                  alt="ic:round-close"
                  onClick={() => props.setIsOpenParse(false)}
                />
              }
              shape="CustomBorderTL16"
              size="xl"
              variant="OutlineGray400_1"
            ></Input>

            <List
              className="flex sm:flex-col flex-row gap-6 w-full"
              orientation="horizontal"
            >
              <div className="py-5 flex flex-col gap-5 items-start justify-start w-full sm:pb-5 px-5 sm:border-b-2 rounded-bl-[16px] rounded-br-[16px] rounded-tl-none rounded-tr-none">
                <Text
                  className="font-semibold text-gray_800 text-left w-auto"
                  as="h5"
                  variant="h5"
                >
                  CMS Video RBT Support
                </Text>
                <div className="flex flex-row items-center justify-between w-full">
                  <Text
                    className="flex-1 font-medium text-gray_800 text-left tracking-[0.14px] w-auto"
                    variant="body1"
                  >
                    Email
                  </Text>
                  <Text
                    className="font-normal not-italic text-black_200 text-left tracking-[0.14px] w-auto"
                    variant="body1"
                  >
                    {informations.vrbt_email}
                  </Text>
                </div>
                <div className="flex flex-row items-center justify-between w-full">
                  <Text
                    className="flex-1 font-medium text-gray_800 text-left tracking-[0.14px] w-auto"
                    variant="body1"
                  >
                    Customer Service (7x24 jam)
                  </Text>
                  <Text
                    className="font-normal not-italic text-black_200 text-left tracking-[0.14px] w-auto"
                    variant="body1"
                  >
                    {informations.vrbt_cs}
                  </Text>
                </div>
                <div className="flex flex-row gap-4 items-start justify-start self-stretch w-auto">
                  <Button
                    className="flex h-[50px] items-center justify-center w-[50px]"
                    shape="icbRoundedBorder6"
                    size="lgIcn"
                    variant="icbFillBlue900"
                    onClick={WhatsAppDPA}
                  >
                    <Img
                      src={process.env.PUBLIC_URL + "/images/img_call.svg"}
                      className=""
                      alt="call"
                    />
                  </Button>
                  <Button
                    className="flex h-[50px] items-center justify-center w-[50px]"
                    shape="icbRoundedBorder6"
                    size="lgIcn"
                    variant="icbFillBlue900"
                    onClick={EmailDPA}
                  >
                    <Img
                      src={
                        process.env.PUBLIC_URL +
                        "/images/img_icbaselineemail.svg"
                      }
                      className="h-6"
                      alt="icbaselineemail"
                    />
                  </Button>
                </div>
              </div>
            </List>
          </div>
        </div>
      </ModalProvider>
    </>
  );
};

export default HelpPopUp;
